module.exports = __webpack_public_path__ + "static/img/bj2.ff27fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homes/bj2.png
// module id = mEeD
// module chunks = 1